import { render, staticRenderFns } from "./epms9060.vue?vue&type=template&id=224dea33&scoped=true"
import script from "./epms9060.vue?vue&type=script&lang=js"
export * from "./epms9060.vue?vue&type=script&lang=js"
import style0 from "./epms9060.vue?vue&type=style&index=0&id=224dea33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224dea33",
  null
  
)

export default component.exports